import moment from 'moment';

import CompanyLogo from '~/components/CompanyLogo';
import { TableCell, TableRow } from '~/components/Table';
import { deepDig } from '~/lib/helpers';

const ROW_HEIGHT = 58;

class ListResponseRow extends React.Component {
  renderDefaultColumn(column, index) {
    const { response } = this.props;

    const value = deepDig(response, column);

    return (
      <TableCell ellipsis key={column} title={value} link={index === 0}>
        {value}
      </TableCell>
    );
  }

  renderCompany(column, index) {
    const { response, classes } = this.props;

    return (
      <TableCell
        key={column}
        ellipsis
        link={index === 0}
        innerClassName={classes.company}>
        {response.company_name && (
          <CompanyLogo domain={response.company_domain} />
        )}
        <div className={classes.companyName}>{response.company_name}</div>
      </TableCell>
    );
  }

  renderTimestamp(column) {
    const { response } = this.props;
    const ts = moment(response[column]);

    return (
      <TableCell ellipsis key={column}>
        <time title={ts.format('LLLL')}>{ts.fromNow()}</time>
      </TableCell>
    );
  }

  renderColumn = (column, index) => {
    switch (column) {
      case 'company_name':
        return this.renderCompany(column, index);
      case 'company_logo':
        return this.renderCompany(column, index);
      case 'submitted_at':
        return this.renderTimestamp(column);
      default:
        return this.renderDefaultColumn(column, index);
    }
  };

  render() {
    const { columns, response, onClick } = this.props;

    return (
      <TableRow
        key={response.id}
        onClick={() => onClick(response)}
        style={{ height: ROW_HEIGHT }}
        hover>
        {columns.map(this.renderColumn)}
      </TableRow>
    );
  }
}

ListResponseRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
  response: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default ListResponseRow;
